__turbopack_context__.v({
  "author": "styles-module__1b2a2G__author",
  "testimonial": "styles-module__1b2a2G__testimonial",
});
